import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../rootReducer'; // Adjust the import path as necessary

export interface PopupState {
  text: string;
}

const initialState: PopupState = {
  text: '',
};

export const popupSlice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    setPopupText: (state, action: PayloadAction<string>) => {
      state.text = action.payload;
    },
  },
});

export const { setPopupText } = popupSlice.actions;

export const selectPopupText = (state: RootState) => state.popup.text;

export default popupSlice.reducer;